<template>
  <div id="student-care-page">
    <div class="top-bar">
      <div class="group-action-button">
        <v-menu offset-y v-if="actionList.length > 0">
          <template #activator="{ on: onMenu }">
            <v-tooltip bottom>
              <template #activator="{ on: onTooltip }">
                <v-btn
                  min-width="45"
                  style="margin-right: 10px;"
                  class="mb-2"
                  color="info"
                  small
                  v-on="{ ...onMenu, ...onTooltip }"
                >
                  <v-icon>mdi-gesture-tap</v-icon>
                </v-btn>
              </template>

              <span>Thao tác</span>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item
              v-for="(action, index) in actionList"
              :key="`${action.id}_${index}`"
              @click="showModalAction(action.type)"
            >
              <v-list-item-title>
                {{ action.title }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
<!--          <v-list v-if="filterForm.blendedTutorTab === TYPE_CALL_STATUS.GIA_HAN || filterForm.blendedTutorTab === TYPE_CALL_STATUS.CHUYEN_SALES">-->
<!--            <v-list-item-->
<!--              v-for="(action, index) in actionExtend"-->
<!--              :key="`${action.id}_${index}`"-->
<!--              @click="showModalAction(action.type)"-->
<!--            >-->
<!--              <v-list-item-title>-->
<!--                {{ action.title }}-->
<!--              </v-list-item-title>-->
<!--            </v-list-item>-->
<!--          </v-list>-->
<!--          <v-list v-if="tab === 0">-->
<!--            <v-list-item-->
<!--              v-for="(action, index) in actionAll"-->
<!--              :key="`${action.id}_${index}`"-->
<!--              @click="showModalAction(action.type)"-->
<!--            >-->
<!--              <v-list-item-title>-->
<!--                {{ action.title }}-->
<!--              </v-list-item-title>-->
<!--            </v-list-item>-->
<!--          </v-list>-->
        </v-menu>
        <v-menu
          :internal-activator="true"
          v-model="filterForm.openRowMenu"
          content-class="menu__customer--filter no-contain overflow-visible"
          :close-on-content-click="false"
          offset-y
        >
          <template #activator="{ on: onMenuCol }">
            <v-tooltip bottom>
              <template #activator="{ on: onTooltipCol }">
                <v-btn
                  v-if="false"
                  min-width="45"
                  small
                  class="mb-2"
                  dark
                  v-on="{ ...onMenuCol, ...onTooltipCol }"
                >
                  <v-icon>mdi-view-column</v-icon>
                </v-btn>
              </template>

              <span>Cột hiển thị</span>
            </v-tooltip>
          </template>
          <CardTableShowField
            :filterForm="filterForm"
          />
        </v-menu>
      </div>
      <div class="tab-container">
        <v-tabs v-model="tab">
          <v-tab @click="toggleTab('blended-task')" v-show="checkTabPermission('BlendedTask')">Công việc</v-tab>
          <v-tab @click="toggleTab('care')" v-show="checkTabPermission('PeriodicallyCareStudent')">Chăm sóc định kì</v-tab>
          <!-- // TODO: add permission in here special-care-student_read -->
          <v-tab @click="toggleTab('incoming-schedule')" v-show="checkTabPermission('IncomingSchedule')">Chăm sóc đặc biệt</v-tab>
          <v-tab @click="toggleTab('extension-tutor')" v-show="checkTabPermission('ExtendTutor')">Gia hạn TUTOR</v-tab>
          <v-tab @click="toggleTab('extension-duo')" v-show="checkTabPermission('ExtendDuo')">Gia hạn DUO</v-tab>
        </v-tabs>
      </div>
      <div class="search-form">
        <v-text-field
          class="search-text-field"
          placeholder="Tìm kiếm theo SDT, mã KH, tên học viên"
          height="25px"
          clearable
          @click:clear="clearSearchField"
          v-model.trim="filterForm.mobile"
          @keyup.enter="searchRecords"
        ></v-text-field>
        <div class="group-btn-search" @click="searchRecords">
          Tìm kiếm
          <v-menu
            :internal-activator="true"
            v-model="filter.closeMenu"
            content-class="menu__customer no-contain overflow-visible"
            :close-on-content-click="false"
            :close-on-click="isCloseOnClick"
            style="z-index: 10"
          >
            <template v-slot:activator="menuON">
              <v-tooltip bottom style="z-index: 10;">
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    medium
                    color="white"
                    v-on="on"
                    class="search-contact--dropdown"
                  >
                    <v-icon size="20"
                            v-on="menuON.on"
                    >mdi-chevron-down
                    </v-icon>
                  </v-btn>
                </template>
                <span>Tìm kiếm nâng cao</span>
              </v-tooltip>
            </template>
            <FilterForm
              v-if="tab !== BLENDED_TAB_INDEX.SPECIAL_CARE"
              :tutorPriority="tutorPriority"
              :filterForm="filterForm"
              :nametab="tab"
              @change-close-on-click="changeCloseOnClick"
              @close="closeMenu"
              @searchContact="searchContact($event)"
              @export="downloadExcel($event)" />
            <filter-special-care
              v-if="tab === BLENDED_TAB_INDEX.SPECIAL_CARE"
              @change-close-on-click="changeCloseOnClick"
              :tutor-priority="tutorPriority"
              :filterForm="filterForm"
              @searchContact="searchContact($event)"
              @close="closeMenu" />
          </v-menu>
        </div>
      </div>
      <div class="d-flex" v-if="true">
        <v-select
          v-model="filterForm.limit"
          :items="limitOptions"
          style="width: 60px"
          @change="searchRecords"
          hide-details
          class="pt-0 mr-4"
        />
        <div class="text-right mb-1 mt-2">
          <template>
            {{ showContactsIndex }}
          </template>
          <v-btn
            small
            class="pagination-btn-left ml-2 mr-2"
            :disabled="filterForm.page == 1"
            @click="previousPage"
          >
            <v-icon>mdi-menu-left</v-icon>
          </v-btn>
          <v-btn
            small
            class="ml-2 mr-2 pagination-btn-right"
            :disabled="filterForm.page >= getTotalItem(totalItem, filterForm.limit)"
            @click="nextpage"
          >
            <v-icon>mdi-menu-right</v-icon>
          </v-btn>
        </div>
        <div style="width: 35px">
          <v-text-field
            v-model="filterForm.pendingPage"
            :max="getTotalItem(totalDataBlendedTutor, filterForm.limit)"
            class="pt-0"
            min="1"
            step="1"
            type="number"
            hide-details
            @input="applyPendingPage(getTotalItem(totalDataBlendedTutor, filterForm.limit))"
          >
          </v-text-field>
        </div>
      </div>
    </div>
    <router-view v-if="tutorPriority" :filterForm="filterForm" :filterFormChange="filterFormChange" :priorityConfig="tutorPriority"></router-view>
    <ModalAddHeadTeacher v-if="isShowAddHeadTeacher" :isShow="isShowAddHeadTeacher" @close-modal-add-head-teacher="isShowAddHeadTeacher = false" />
    <modal-change-sale v-if="isShowModalChangeSale" :isShow="isShowModalChangeSale" :isValidNoSale="isValidNoSale" @close-modal-add-head-teacher="isShowModalChangeSale = false" :tab="tab"/>
  </div>
</template>

<script>
import checkPermission from '@/modules/student_care/mixins/checkPermission';
import { mapActions, mapGetters, mapState } from 'vuex';
import { TYPE_CALL_STATUS, TYPE_CALL_STATUS_STUDENT, TYPE_CURRICULUM_OBJ } from '@/helpers/constant';
import _ from 'lodash';
import BlendedCareRepository from '@/services/BlendedCareRepository';
import StudentCareServices from '@/services/StudentCareServices';
import FilterForm from './components/FilterFormCard.vue';
import ModalAddHeadTeacher from './components/ModalAddHeadTeacher.vue';
import ModalChangeSale from './components/ModalChangeSale.vue';
import {
  BLENDED_TUTOR_ACTION_PERMISSION,
  BLENDED_TAB_INDEX,
  downloadPermissionTab,
  permissionCheckMenuBlended,
  permissionWithRouterName,
  routerNameWithPermission, permissionCheckMenuBlendedSecondary, routerNameWithPermissionSecondary,
} from './const';
import FilterSpecialCare from './components/filterSpecialCare.vue';

export default {
  name: 'StudentList',
  components: {
    FilterForm,
    ModalAddHeadTeacher,
    ModalChangeSale,
    FilterSpecialCare,
  },
  mixins: [checkPermission],
  data() {
    return {
      isCloseOnClick: true,
      BLENDED_TAB_INDEX,
      changeTabLoader: null,
      debounceTimeout: null,
      isValidNoSale: true,
      tutorPriority: null,
      filterFormOriginal: {},
      filter: {
        closeMenu: false,
      },
      TYPE_CALL_STATUS,
      tab: 0,
      filterForm: {
        sortAppointmentSchedule: 'desc',
        mobile: '',
        searchInfo: '',
        page: 1,
        limit: 20,
        headTeacher: [],
        blendedTutorTab: 0,
        pendingPage: 1,
        compareTypeNumberOfLessons: 'eq',
        compareTypeLatestCareDate: 'between',
        hasNoTeacher: false,
        hasNoSale: false,
        classCode: '',
        subjectIds: [],
        curriculumIds: [],
        callStatusIds: [],
        homeroomTeacherIds: [],
        userIds: [],
        productIds: [],
        typeLastestCareDate: 'eq',
        numberLastestCareDate: null,
        typeLessonPassed: 'eq',
        numberLessonPassed: null,
        studentStatusTutor: [],
        studentStatusDuo: [],
        sales: [],
        type_curriculum: 'online',
        checkboxAll: false,
        sortUpdatedAt: 'desc',
        programFilter: [],
        program_ids: [],
        extend_sale_at: null,
        isNullEndDate: false,
        endDate: [],
        specialInAt: [],
        specialOutDateAt: [],
        isSpecialOutDate: 0,
        typeScreen: 'blended',
        numberLastestCareDateFrom: null,
        numberLastestCareDateTo: null,
        courseId: null,
      },
      filterFormChange: {},
      isShowAddHeadTeacher: false,
      isShowModalChangeSale: false,
      downloadPermissionTab,
      limitOptions: [10, 20, 50, 100, 200, 500],
    };
  },
  mounted() {
    const loading = this.$loading.show();
    this.filterFormOriginal = _.cloneDeep(this.filterForm);
    if (this.$route.name === 'PeriodicallyCareStudent') {
      this.tab = BLENDED_TAB_INDEX.PERIODICALLY_CARE;
      this.filterForm.blendedTutorTab = TYPE_CALL_STATUS_STUDENT.CHAM_SOC_DINH_KY;
    } else if (this.$route.name === 'IncomingSchedule') {
      this.tab = BLENDED_TAB_INDEX.SPECIAL_CARE;
      this.filterForm.isSpecialCare = 1;
      this.filterForm.blendedTutorTab = TYPE_CALL_STATUS_STUDENT.LICH_SAP_DEN;
      this.filterForm.mobile = this.$route.query.contactCode ? this.$route.query.contactCode : '';
    } else if (this.$route.name === 'ExtendTutor') {
      this.tab = BLENDED_TAB_INDEX.EXTEND_TUTOR;
      this.filterForm.blendedTutorTab = TYPE_CALL_STATUS_STUDENT.GIA_HAN_TUTOR;
    } else if (this.$route.name === 'ExtendDuo') {
      this.tab = BLENDED_TAB_INDEX.EXTEND_DUO;
      this.filterForm.blendedTutorTab = TYPE_CALL_STATUS_STUDENT.GIA_HAN_DUO;
    }
    loading.hide();
  },
  async created() {
    Bus.$on('reloadListTask', () => {
      this.filterForm.phoneNumber = this.filterForm.mobile;
      Bus.$emit('recountTotalSuccess');
      this.filterForm.tutorSchoolLevel = this.$route.query.schoolLevel;
      this.getListTask(this.filterForm);
    });
    const loading = this.$loading.show();
    await this.getPriorityConfigConfig();
    await this.handleDirectBlendedRoute();
    Bus.$on('reload-page-blended', async () => {
      this.getListCallStatusBlendedCount({
        ...this.filterForm,
        typeBlended: this.tutorPriority,
        school_level: this.$route.query.schoolLevel,
      });
      this.getListStatusBlendedTutor({
        blendedTutorTab: this.filterForm.blendedTutorTab ? this.filterForm.blendedTutorTab : null,
        type_curriculum: this.filterForm.type_curriculum,
      });
      await this.getDataBlendedTutor({
        ...this.filterForm,
        typeBlended: this.tutorPriority,
        school_level: this.$route.query.schoolLevel,
      });
      this.filterForm.checkboxAll = false;
    });
    loading.hide();
  },
  methods: {
    ...mapActions('student_care', ['getCourseExtensionShowField', 'getListGVCN', 'getDataPeriodicallyCareTable', 'getListSale', 'apiUpdate', 'getListTotalGVCN', 'apiUpdateCSDK', 'getListProgram', 'apiUpdateGiaHan', 'getListSaleForRole', 'getListGVCNV2']),
    ...mapActions('blended', ['getDataBlendedTutor', 'getListCallStatusBlendedCount', 'getListStatusBlendedTutor', 'changeLoadingState', 'getListTask']),
    changeCloseOnClick(val) {
      this.isCloseOnClick = val;
    },
    checkTabPermission(tabName) {
      const { schoolLevel } = this.$route.query;
      // eslint-disable-next-line no-nested-ternary
      const routeNamePermission = schoolLevel === 'primary' ? routerNameWithPermission : schoolLevel === 'secondary' ? routerNameWithPermissionSecondary : [];
      return this.checkPermission(routeNamePermission[tabName]);
    },
    async fetchData() {
      this.changeLoadingState(true);
      if (this.tab !== BLENDED_TAB_INDEX.TASK) {
        Promise.allSettled([
          this.getListCallStatusBlendedCount({
            ...this.filterForm,
            typeBlended: this.tutorPriority,
            school_level: this.$route.query.schoolLevel,
          }),
          this.getListStatusBlendedTutor({
            blendedTutorTab: this.filterForm.blendedTutorTab ? this.filterForm.blendedTutorTab : null,
            type_curriculum: this.filterForm.type_curriculum,
          }),
          this.getListGVCNV2(),
          this.getSale(),
          this.getListTotalGVCN(),
          this.getListProgram(),
        ]);
        await this.getDataBlendedTutor({
          ...this.filterForm,
          typeBlended: this.tutorPriority,
          school_level: this.$route.query.schoolLevel,
        });
      } else {
        this.filterForm.phoneNumber = this.filterForm.mobile;
        this.filterForm.tutorSchoolLevel = this.$route.query.schoolLevel;
        this.getListGVCN();
        this.getListGVCNV2();
        this.getListTotalGVCN();
        await this.getListTask(this.filterForm);
      }
      this.changeLoadingState(false);
    },
    getSale() {
      if (this.$route.query.typeCurriculum === 'online') {
        this.getListSaleForRole();
      } else {
        this.getListSale();
      }
    },
    async getPriorityConfigConfig() {
      const loading = this.$loading.show();
      const result = await BlendedCareRepository.getPriorityConfig();
      if (result.message === 'Success') {
        this.tutorPriority = result.data.find((item) => item.product_line_name === 'tutor').priority;
        // result.data.forEach((item) => {
        //   if (item.product_line_name === 'tutor') {
        //     debugger;
        //     this.tutorPriority = item.priority;
        //   }
        // });
      }
      loading.hide();
    },
    applyPendingPage(maxPage) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        if (this.filterForm.pendingPage < 1) {
          this.filterForm.pendingPage = this.filterForm.page;
          this.getDataBlendedTutor({
            ...this.filterForm,
            school_level: this.$route.query.schoolLevel,
            typeBlended: this.tutorPriority,
          });
          return;
        }
        if (this.filterForm.pendingPage > maxPage) {
          this.filterForm.pendingPage = maxPage;
          this.filterForm.page = parseInt(this.filterForm.pendingPage, 10);
          this.getDataBlendedTutor({
            ...this.filterForm,
            school_level: this.$route.query.schoolLevel,
            typeBlended: this.tutorPriority,
          });
          return;
        }
        this.filterForm.page = parseInt(this.filterForm.pendingPage, 10);
        this.getDataBlendedTutor({
          ...this.filterForm,
          school_level: this.$route.query.schoolLevel,
          typeBlended: this.tutorPriority,
        });
        this.filterForm.checkboxAll = false;
      }, 400);
    },
    async previousPage() {
      const loading = this.$loading.show();
      this.filterForm.page -= 1;
      if (this.tab === BLENDED_TAB_INDEX.TASK) {
        this.filterForm.phoneNumber = this.filterForm.mobile;
        this.filterForm.tutorSchoolLevel = this.$route.query.schoolLevel;
        await this.getListTask(this.filterForm);
      } else {
        await this.getDataBlendedTutor({
          ...this.filterForm,
          school_level: this.$route.query.schoolLevel,
          typeBlended: this.tutorPriority,
        });
      }
      this.filterForm.checkboxAll = false;
      this.filterForm.pendingPage -= 1;
      loading.hide();
    },
    async nextpage() {
      const loading = this.$loading.show();
      this.filterForm.page += 1;
      if (this.tab === BLENDED_TAB_INDEX.TASK) {
        this.filterForm.phoneNumber = this.filterForm.mobile;
        this.filterForm.tutorSchoolLevel = this.$route.query.schoolLevel;
        await this.getListTask(this.filterForm);
      } else {
        await this.getDataBlendedTutor({
          ...this.filterForm,
          school_level: this.$route.query.schoolLevel,
          typeBlended: this.tutorPriority,
        });
      }
      this.filterForm.checkboxAll = false;
      this.filterForm.pendingPage += 1;
      loading.hide();
    },
    async searchRecords() {
      const loading = this.$loading.show();
      this.filterForm.page = 1;
      this.filterForm.pendingPage = 1;
      if (this.tab === BLENDED_TAB_INDEX.TASK) {
        Bus.$emit('recountTotalSuccess');
        this.filterForm.phoneNumber = this.filterForm.mobile;
        this.filterForm.tutorSchoolLevel = this.$route.query.schoolLevel;
        await this.getListTask(this.filterForm);
      } else {
        this.getListCallStatusBlendedCount({
          ...this.filterForm,
          typeBlended: this.tutorPriority,
          school_level: this.$route.query.schoolLevel,
        });
        await this.getDataBlendedTutor({
          ...this.filterForm,
          typeBlended: this.tutorPriority,
          school_level: this.$route.query.schoolLevel,
        });
      }
      loading.hide();
    },
    clearSearchField() {
      this.filterForm.mobile = '';
      this.searchRecords();
    },
    async toggleTab(tab) {
      this.changeTabLoader = this.$loading.show();
      const searchText = this.filterForm.mobile;
      if (tab === 'blended-task' && this.filterForm.blendedTutorTab !== 'blended-task') {
        this.filterForm = _.cloneDeep(this.filterFormOriginal);
        this.filterForm.blendedTutorTab = 'blended-task';
        this.filterForm.mobile = searchText;
        this.filterForm.phoneNumber = this.filterForm.mobile;
        await this.$router.replace({ name: 'BlendedTask', query: { typeCurriculum: this.$store?.state?.typeCurriculum, schoolLevel: this.$route.query.schoolLevel } });
        this.filterForm.tutorSchoolLevel = this.$route.query.schoolLevel;
        await this.getListTask(this.filterForm);
      }
      if (tab === 'care' && this.filterForm.blendedTutorTab !== TYPE_CALL_STATUS_STUDENT.CHAM_SOC_DINH_KY) {
        this.filterForm = _.cloneDeep(this.filterFormOriginal);
        this.filterForm.blendedTutorTab = TYPE_CALL_STATUS_STUDENT.CHAM_SOC_DINH_KY;
        this.filterForm.mobile = searchText;
        await this.$router.replace({ name: 'PeriodicallyCareStudent', query: { typeCurriculum: this.$store?.state?.typeCurriculum, schoolLevel: this.$route.query.schoolLevel } });
        await this.fetchData();
      } else if (tab === 'extension-tutor' && this.filterForm.blendedTutorTab !== TYPE_CALL_STATUS_STUDENT.GIA_HAN_TUTOR) {
        this.filterForm = _.cloneDeep(this.filterFormOriginal);
        this.filterForm.blendedTutorTab = TYPE_CALL_STATUS_STUDENT.GIA_HAN_TUTOR;
        this.filterForm.mobile = searchText;
        await this.$router.replace({ name: 'ExtendTutor', query: { typeCurriculum: this.$store?.state?.typeCurriculum, schoolLevel: this.$route.query.schoolLevel } });
        await this.fetchData();
      } else if (tab === 'extension-duo' && this.filterForm.blendedTutorTab !== TYPE_CALL_STATUS_STUDENT.GIA_HAN_DUO) {
        this.filterForm = _.cloneDeep(this.filterFormOriginal);
        this.filterForm.type_curriculum = 'duo';
        this.filterForm.blendedTutorTab = TYPE_CALL_STATUS_STUDENT.GIA_HAN_DUO;
        this.filterForm.mobile = searchText;
        await this.$router.replace({ name: 'ExtendDuo', query: { typeCurriculum: this.$store?.state?.typeCurriculum, schoolLevel: this.$route.query.schoolLevel } });
        await this.fetchData();
      } else if (tab === 'incoming-schedule' && this.filterForm.blendedTutorTab !== TYPE_CALL_STATUS_STUDENT.LICH_SAP_DEN) {
        this.filterForm = _.cloneDeep(this.filterFormOriginal);
        this.filterForm.blendedTutorTab = TYPE_CALL_STATUS_STUDENT.LICH_SAP_DEN;
        // this.filterForm.mobile = searchText;
        await this.$router.replace({ name: 'IncomingSchedule', query: { typeCurriculum: this.$store?.state?.typeCurriculum, schoolLevel: this.$route.query.schoolLevel } });
        this.filterForm.isSpecialCare = 1;
        this.filterForm.mobile = this.$route.query.contactCode ? this.$route.query.contactCode : searchText;
        await this.fetchData();
      }
      this.changeTabLoader.hide();
    },
    showModalAction(modalType) {
      if (modalType === 'add_head_teacher') {
        const listSelectedId = [];
        this.dataBlendedTutor.forEach(
          (contact) => {
            if (contact.checkbox) {
              listSelectedId.push(contact.id);
            }
          },
        );
        if (listSelectedId.length === 0) {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Vui lòng chọn khách hàng !!!',
          });
        } else {
          this.isShowAddHeadTeacher = true;
        }
        return;
      }
      // if (this.dataPeriodicallyCareTable && this.dataPeriodicallyCareTable.data && this.dataPeriodicallyCareTable.data.length > 0) {
      //   for (let i = 0; i < this.dataPeriodicallyCareTable.data.length; i += 1) {
      //     if (this.dataPeriodicallyCareTable.data[i] && this.dataPeriodicallyCareTable.data[i].checkbox) {
      //       if (modalType === 'add_head_teacher') {
      //         this.isShowModalAddHeadTeacher = true;
      //         return;
      //       }
      if (modalType === 'change_sale') {
        const listSelectedId = [];
        this.isValidNoSale = true;
        this.dataBlendedTutor.forEach(
          (contact) => {
            if (contact.checkbox) {
              listSelectedId.push(contact.id);
              if (contact.type_customer_care !== 2 && contact.type_customer_care !== 1 && contact.type_customer_care !== 4) {
                this.isValidNoSale = false;
              }
            }
          },
        );
        if (listSelectedId.length === 0) {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Vui lòng chọn khách hàng !!!',
          });
        } else {
          this.isShowModalChangeSale = true;
        }
        return;
      }
      if (modalType === 'move_to_early_extension_tutor') {
        this.$swal({
          title: 'Bạn có chắc chắn muốn chuyển gia hạn sớm',
          confirmButtonText: 'Chuyển gia hạn sớm',
          showCancelButton: true,
          cancelButtonText: 'Quay lại',
        }).then((res) => {
          if (res.value) {
            this.moveToEarlyExtension('move_to_early_extension_tutor');
          }
        });
      }
      if (modalType === 'move_to_early_extension_duo') {
        this.$swal({
          title: 'Bạn có chắc chắn muốn chuyển gia hạn sớm',
          confirmButtonText: 'Chuyển gia hạn sớm',
          showCancelButton: true,
          cancelButtonText: 'Quay lại',
        }).then((res) => {
          if (res.value) {
            this.moveToEarlyExtension('move_to_early_extension_duo');
          }
        });
      }
    },
    async searchContact(data) {
      this.filter.closeMenu = false;
      const loading = this.$loading.show();
      this.filterForm = _.cloneDeep(data);
      this.filterForm.page = 1;
      this.filterForm.pendingPage = 1;
      if (this.tab === BLENDED_TAB_INDEX.TASK) {
        this.filterForm.phoneNumber = this.filterForm.mobile;
        this.filterForm.tutorSchoolLevel = this.$route.query.schoolLevel;
        await this.getListTask(this.filterForm);
        Bus.$emit('recountTotalSuccess');
      } else {
        this.getListCallStatusBlendedCount({
          ...this.filterForm,
          typeBlended: this.tutorPriority,
          school_level: this.$route.query.schoolLevel,
        });
        await this.getDataBlendedTutor({
          ...this.filterForm,
          typeBlended: this.tutorPriority,
          school_level: this.$route.query.schoolLevel,
        });
      }
      loading.hide();
    },
    async downloadExcel(filterForm) {
      Bus.$emit('download-excel-filter-blended', {
        ...filterForm,
        typeBlended: this.tutorPriority,
        school_level: this.$route.query.schoolLevel,
      });
    },
    async moveToEarlyExtension(type) {
      const listSelectedId = [];
      this.dataBlendedTutor.forEach(
        (contact) => {
          if (contact.checkbox) {
            listSelectedId.push(type === 'move_to_early_extension_tutor' ? contact.id : contact.duoId);
          }
        },
      );
      if (listSelectedId.length === 0) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Vui lòng chọn khách hàng !!!',
        });
      }

      let result = null;
      if (type === 'move_to_early_extension_tutor') {
        const params = {
          ids: listSelectedId,
        };
        result = await this.apiUpdateGiaHan(params);
      } else {
        result = await StudentCareServices.moveToExtend({
          routineStudentIdList: listSelectedId.filter((id) => id),
          typeCustomerCare: this.tab === BLENDED_TAB_INDEX.EXTEND_DUO ? 2 : undefined,
        });
      }
      if (result && !result.error) {
        this.$swal({
          type: 'success',
          title: 'Thành công',
          text: result.data,
          timer: 1500,
        });
        Bus.$emit('reload-page-blended');
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: result.message ? result.message : 'Có lỗi khi chuyển !!!',
        });
      }
      return 0;
    },
    async handleDirectBlendedRoute() {
      const { schoolLevel } = this.$route.query;
      // eslint-disable-next-line no-nested-ternary
      const permissionCheckMenu = schoolLevel === 'primary' ? permissionCheckMenuBlended : schoolLevel === 'secondary' ? permissionCheckMenuBlendedSecondary : [];
      // eslint-disable-next-line no-nested-ternary
      const routerNameWithPermissionConst = schoolLevel === 'primary' ? routerNameWithPermission : schoolLevel === 'secondary' ? routerNameWithPermissionSecondary : [];
      const blendedPermissionUser = _.intersection(permissionCheckMenu, this.$store.state.permissions);
      if (!blendedPermissionUser || !blendedPermissionUser.length) return;
      const currentPermission = routerNameWithPermissionConst[this.$route.name];
      const firstPermission = currentPermission && permissionWithRouterName[currentPermission] && blendedPermissionUser.includes(currentPermission)
        ? permissionWithRouterName[currentPermission]
        : permissionWithRouterName[blendedPermissionUser[0]];
      if (!firstPermission) return;
      this.filterForm.blendedTutorTab = firstPermission.tabBlended;
      this.filterForm.type_curriculum = this.$store?.state?.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE ? 'online' : this.$store?.state?.typeCurriculum;
      this.tab = firstPermission.tab;
      if (this.$route.name !== firstPermission['router-name']) {
        await this.$router.push({
          name: firstPermission['router-name'],
          query: { typeCurriculum: this.$store?.state?.typeCurriculum, schoolLevel: this.$route.query.schoolLevel },
        });
      }
      await Promise.all([
        // this.getListStatusBlendedTutor({
        //   type_curriculum: _.cloneDeep(this.$store.state.typeCurriculum),
        // }),
        this.fetchData(),
      ]);
    },
    closeMenu() {
      this.filter.closeMenu = false;
    },
  },
  beforeDestroy() {
    if (this.changeTabLoader) {
      this.changeTabLoader.hide();
    }
  },
  computed: {
    ...mapGetters('contact_status', ['mapCallStatus']),
    ...mapState('blended', ['dataBlendedTutor', 'totalContactModule', 'totalDataBlendedTutor', 'tasks']),
    showContactsIndex() {
      const maxIndex = parseInt(this.filterForm.page, 10) * parseInt(this.filterForm.limit, 10);
      if (maxIndex >= this.totalItem) {
        return `${maxIndex - parseInt(this.filterForm.limit, 10) + 1} - ${parseInt(this.totalItem, 10)}`;
      }
      return `${maxIndex - parseInt(this.filterForm.limit, 10) + 1} - ${maxIndex}`;
    },
    totalItem() {
      if (this.tab === BLENDED_TAB_INDEX.TASK) {
        return this.tasks.count;
      }
      return this.totalDataBlendedTutor;
    },
    actionAll() {
      return [];
    },
    actionList() {
      const actionList = [];
      const actionListTemp = BLENDED_TUTOR_ACTION_PERMISSION.find((e) => e.tabIndex === this.tab) ? BLENDED_TUTOR_ACTION_PERMISSION.find((e) => e.tabIndex === this.tab).actions : [];
      actionListTemp.forEach((e) => {
        if (this.$route.query.schoolLevel && this.checkPermission(e.permission[this.$route.query.schoolLevel])) {
          actionList.push({
            title: e.title,
            type: e.type,
            store: 'all',
          });
        }
      });
      return actionList;
    },
  },
  watch: {
    tab: {
      handler(val) {
        const searchText = this.filterForm.mobile;
        this.filterFormOriginal.blendedTutorTab = this.filterForm.blendedTutorTab;
        this.filterForm = _.cloneDeep(this.filterFormOriginal);
        this.filterForm.mobile = searchText;
        if (val === BLENDED_TAB_INDEX.TASK) {
          this.filterForm.phoneNumber = searchText;
        }
        if (val === BLENDED_TAB_INDEX.EXTEND_DUO) {
          this.filterForm.type_curriculum = 'duo';
        }
        if (val === BLENDED_TAB_INDEX.SPECIAL_CARE) {
          this.filterForm.isSpecialCare = 1;
          this.filterForm.mobile = this.$route.query.contactCode ? this.$route.query.contactCode : '';
        }
      },
    },
    '$route.name': {
      async handler() {
        this.handleActiveRoute('blended-care');
        const loading = this.$loading.show();
        if (this.$route.name === 'IncomingSchedule') {
          this.filterForm = _.cloneDeep(this.filterFormOriginal);
          this.filterForm.blendedTutorTab = TYPE_CALL_STATUS_STUDENT.LICH_SAP_DEN;
          this.filterForm.isSpecialCare = 1;
        }
        // if (this.$route.name === 'PeriodicallyCareStudent') {
        //   this.$router.replace({ name: 'PeriodicallyCareStudent', query: { typeCurriculum: this.$store?.state?.typeCurriculum } });
        //   this.filterForm = _.cloneDeep(this.filterFormOriginal);
        //   this.tab = 0;
        //   this.filterForm.blendedTutorTab = TYPE_CALL_STATUS_STUDENT.CHAM_SOC_DINH_KY;
        //   this.filterForm.type_curriculum = this.$store?.state?.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE ? 'online' : this.$store?.state?.typeCurriculum;
        //   await Promise.all([
        //     this.getListStatusBlendedTutor({
        //       type_curriculum: _.cloneDeep(this.$store.state.typeCurriculum),
        //     }),
        //     this.fetchData(),
        //   ]);
        // }
        if (this.$route.name === 'StudentList') {
          await this.handleDirectBlendedRoute();
        }
        loading.hide();
      },
    },
  },
};
</script>

<style scoped>
.top-bar {
  min-height: 46px;
  min-width: 900px;
  border-radius: 0px;
  background: #FFFFFF;
  padding: 0px 15px 0px 15px;
  display: flex;
  justify-content: space-between;
}

.second-bar {
  margin-top: 15px;
  min-height: 39px;
  min-width: 900px;
  border-radius: 0px;
  background: #FFFFFF;
  display: flex;
  justify-content: flex-start;
}

.quick-filter-action {
  min-height: 39px;
  border-radius: 0px;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  padding: 13px;
  margin-right: 1px;
  cursor: pointer;
}

.button-create {
  background-color: #e91e63 !important;
  border-color: #e91e63 !important;
}

.group-btn-search {
  height: 30px;
  min-width: 80px;
  background: #E91E63;
  border-radius: 3px;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 17px;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  padding: 9px;
  margin-left: 20px;
  cursor: pointer;
}

.search-form {
  min-width: 250px;
  height: 22px;
  display: flex;
  justify-content: flex-start;
  padding-top: 9px;
}

.group-action-button {
  padding-top: 9px;
}
@media screen and (max-width: 1600px) {
  .tab-container {
    width: 600px;
  }
}
@media screen and (max-width: 1450px) {
  .tab-container {
    width: 530px;
  }
}
</style>
